import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { RESERVATIONS_SERVICE_PATH } from '../paths';
import { LoginForm } from './LoginForm';

export const LoginPage = () => {
  const { isLoading, isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const returnTo = searchParams.get('returnTo');

  useEffect(() => {
    if (isAuthenticated) {
      if (returnTo) {
        try {
          const decodedReturnTo = decodeURIComponent(returnTo);
          if (decodedReturnTo.startsWith('/')) {
            navigate(decodedReturnTo);
            return;
          }
        } catch (_) {
          // eslint-disable-next-line no-console
          console.warn('Invalid returnTo parameter:', returnTo);
        }
      }

      navigate(RESERVATIONS_SERVICE_PATH);
    }
  }, [isLoading, isAuthenticated, returnTo]);

  return isLoading ? null : <LoginForm />;
};
